import { render, staticRenderFns } from "./DashboardSummaryStatusCard.vue?vue&type=template&id=054a2144&scoped=true"
import script from "./DashboardSummaryStatusCard.vue?vue&type=script&lang=js"
export * from "./DashboardSummaryStatusCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardSummaryStatusCard.vue?vue&type=style&index=0&id=054a2144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a2144",
  null
  
)

export default component.exports